import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAssetsForProduct, getImageVarients, getSingleProduct } from "../../services/ProductService";

const initialState = {
   isLoading: false,
   error: null,
   isQuickView:false,
   productDetails:{},
   assetDetails:[],
   variantDetails:[]
   
};
export const fetchProductDetails= createAsyncThunk(
  "/get-product",
  async (id) => {
    const response = await getSingleProduct(id);
    return response.data; 
  }
);
export const fetchAssetsDetials= createAsyncThunk(
  "/get-assets",
  async (id) => {
    const response = await getAssetsForProduct(id);
    return response.data; 
  }
);
export const fetchVariantDetails= createAsyncThunk(
    "/get-variants",
    async (id) => {
      const response = await getImageVarients(id);
      return response.data; 
    }
  );
export const productDetailsSlice = createSlice({
  name: "productDetailsSlice",
  initialState,
  reducers: {
   
    emptyProductDetails: (state) => {
      state.productDetails = {};
    },
    setIsQuickView :(state,action)=>{
        state.isQuickView = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productDetails = action.payload; 
        
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to main category details";
        console.error("Fetch main category details failed:", action.error);
      })
      .addCase(fetchAssetsDetials.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        
      })
      .addCase(fetchAssetsDetials.fulfilled, (state, action) => {
        state.isLoading = false;
        state.assetDetails = action.payload; 
        
      })
      .addCase(fetchAssetsDetials.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to sub  category  details";
        console.error("Fetch sub category details failed:", action.error);
      })
      .addCase(fetchVariantDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        
      })
      .addCase(fetchVariantDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.variantDetails = action.payload; 
        
      })
      .addCase(fetchVariantDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to sub  category  details";
        console.error("Fetch sub category details failed:", action.error);
      });
  },
});

export const { emptyProductDetails, setIsQuickView } = productDetailsSlice.actions;


export default productDetailsSlice.reducer;
